import React, { useState, useEffect } from 'react';
import './Leaderboard.css';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig';
import { useNavigate } from 'react-router-dom';
import countries from 'world-countries';
import FooterLinks from './FooterLinks';

const medalIcons = [
	'🥇', // Gold for first place
	'🥈', // Silver for second place
	'🥉', // Bronze for third place
];

function Leaderboard() {
	const [entries, setEntries] = useState([]);
	const [copied, setCopied] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;
	const navigate = useNavigate();

	useEffect(() => {
		const fetchLeaderboard = async () => {
			try {
				const leaderboardRef = collection(db, 'challenge_leaderboard', 'Nolan', 'entries');
				const q = query(leaderboardRef, orderBy('levelsReached', 'desc'), orderBy('timeTaken', 'asc'));
				const snapshot = await getDocs(q);
				const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
				setEntries(data);
			} catch (error) {
				console.error('Error fetching leaderboard:', error);
			}
		};

		fetchLeaderboard();
	}, []);

	const getCountryCode = (countryName) => {
		const country = countries.find((c) => c.name.common.toLowerCase() === countryName.toLowerCase());
		return country ? country.cca2.toLowerCase() : '';
	};

	const getCountryFlagUrl = (countryName) => {
		const countryCode = getCountryCode(countryName);
		if (!countryCode) return '';
		return `https://flagcdn.com/w40/${countryCode}.png`;
	};

	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const currentEntries = entries.slice(startIndex, endIndex);

	const nextPage = () => {
		if (endIndex < entries.length) setCurrentPage(currentPage + 1);
	};

	const prevPage = () => {
		if (currentPage > 1) setCurrentPage(currentPage - 1);
	};

	const shareGame = () => {
		const message =
			'Nolan Movie Quotes Challenge! I am on the leaderboard! Can you guess the quotes faster?\nTry it here: https://moviequotesguesser.com/challenge \n';
		navigator.clipboard.writeText(message).then(() => setCopied(true));
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<div className="leaderboard-container">
			<h1 className="leaderboard-title">Nolan Challenge - Top 50</h1>
			<div className="leaderboard-list">
				{currentEntries.map((entry, index) => {
					const medal = index < 3 && currentPage === 1 ? medalIcons[index] : null;
					return (
						<div key={entry.id} className="leaderboard-row">
							<span className="leaderboard-rank">{medal || `#${startIndex + index + 1}`}</span>
							<span className="leaderboard-username">{entry.username}</span>
							<span className="leaderboard-country">
								{entry.country && <img src={getCountryFlagUrl(entry.country)} alt="Flag" />}
								<span className="leaderborad-country-text">{entry.country}</span>
							</span>
							<span className="leaderboard-level">Lvl {entry.levelsReached}</span>
							<span className="leaderboard-time">{entry.timeTaken.toFixed(1)}s</span>
						</div>
					);
				})}
			</div>
			<div className="pagination-controls">
				<button onClick={prevPage} disabled={currentPage === 1} className="pagination-button">
					&lt;
				</button>
				<span>Page {currentPage}</span>
				<button onClick={nextPage} disabled={endIndex >= entries.length} className="pagination-button">
					&gt;
				</button>
			</div>
			<div className="leaderboard-back">
				<button onClick={() => navigate('/')} className="back-button">
					Home
				</button>
				<button onClick={() => navigate('/challenge')} className="play-again-button">
					Play Again
				</button>
				<button onClick={shareGame} className="challenge-share-button">
					{copied ? 'Copied!' : 'Share This Game'}
				</button>
			</div>
			<footer className="leaderboard-footer">
				<FooterLinks />
			</footer>
		</div>
	);
}

export default Leaderboard;
